<!-- <ng-template #quillToolbar>
    <span class="ql-formats">
        <button class="ql-bold hover:bg-primary-100 rounded"></button>
        <button class="ql-italic hover:bg-primary-100 rounded"></button>
    </span>
</ng-template> -->
<input type="file" #fileUpload [accept]="'.json'" (change)="onLoad($event)" class="hidden">
<div class="flex flex-row gap-4 {{ isEditable ? 'justify-start' : 'justify-end' }} items-center px-4">
    @if(isEditable) {
    <btn-text label="Save" (onClick)="onSave()" prefixIcon="fa fa-save"></btn-text>
    <div class="w-[1px] h-4 bg-primary-300 rounded"></div>
    <btn-text label="Import" (onClick)="fileUpload.click()" prefixIcon="fa fa-download"></btn-text>
    <div class="w-[1px] h-4 bg-primary-300 rounded"></div>
    }
    <btn-text label="Print" (onClick)="onPrint()" prefixIcon="fa fa-print"></btn-text>
</div>
<div #quillContainer>
    <div #quillEditor class="ql-container">
        <quill-editor #editorContent [(ngModel)]="jsonFormat" format="json" [modules]="editorModules"
            class="w-full overflow-auto border-0" [readOnly]="!isEditable" (onEditorCreated)="onEditorCreated($event)"
            (onContentChanged)="onContentChanged($event)"></quill-editor>
    </div>
</div>